import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPolls = store => store[NAME].polls;
export const getQuestionTypes = store => store[NAME].questionTypes;
export const getVisualizationTypeList = store => store[NAME].visualizationTypeList;
export const getPollTypes = store => store[NAME].pollTypes;
export const getProcessList = store => store[NAME].processList;
export const getDateFormat = store => store[NAME].dateFormat;
export const getModes = store => store[NAME].modes;
export const getOnaTypeList = store => store[NAME].onaTypeList;
export const getPositionList = store => store[NAME].positionList;
export const getEmployeeList = store => store[NAME].employeeList;